import { conventionalBnbPoolV1Address } from "@quint/services/web3/hooks/conventional-bnb-pool-v1";
import { conventionalBnbPoolV2Address } from "@quint/services/web3/hooks/conventional-bnb-pool-v2";
import { conventionalPoolV1Address } from "@quint/services/web3/hooks/conventional-pool-v1";
import { conventionalPoolV2Address } from "@quint/services/web3/hooks/conventional-pool-v2";
import { type HTMLProps } from "react";
import { LogoIcon } from "../logo-icon";
import { type StakingCardDatum } from "../types";
import {
  QuintBNBV1CurrentlyStaked,
  QuintBNBV1HarvestButton,
  QuintBNBV1MigrateButton,
  QuintBNBV1Rewards,
  QuintBNBV1TotalHarvested,
  QuintBNBV1UnstakeButton,
} from "./quint-bnb-v1";
import {
  QuintBNBV2CurrentlyStaked,
  QuintBNBV2HarvestButton,
  QuintBNBV2Rewards,
  QuintBNBV2TotalHarvested,
  QuintBNBV2UnstakeDialog,
  renderQuintBNBV2StakeButton,
} from "./quint-bnb-v2";
import {
  QuintV1CurrentlyStaked,
  QuintV1HarvestButton,
  QuintV1MigrateButton,
  QuintV1Rewards,
  QuintV1TotalHarvested,
  QuintV1UnstakeButton,
} from "./quint-v1";
import {
  QuintV2CurrentlyStaked,
  QuintV2HarvestButton,
  QuintV2Rewards,
  QuintV2TotalHarvested,
  QuintV2UnstakeDialog,
  renderQuintV2StakeButton,
} from "./quint-v2";

export const pools: StakingCardDatum[] = [
  {
    name: "Quint V1",
    Icon: (props: HTMLProps<HTMLDivElement>) => <LogoIcon color="#292929" {...props} />,
    deprecated: true,
    currentlyStaked: <QuintV1CurrentlyStaked />,
    totalHarvested: <QuintV1TotalHarvested />,
    rewards: <QuintV1Rewards />,
    apr: "15.00%",
    apy: "16.18%*",
    unstakeButton: <QuintV1UnstakeButton />,
    harvestButton: <QuintV1HarvestButton />,
    migrateButton: <QuintV1MigrateButton />,
    address: conventionalPoolV1Address,
  },
  {
    name: "Quint V2",
    Icon: (props: HTMLProps<HTMLDivElement>) => <LogoIcon color="#344A4C" {...props} />,
    deprecated: false,
    currentlyStaked: <QuintV2CurrentlyStaked />,
    totalHarvested: <QuintV2TotalHarvested />,
    rewards: <QuintV2Rewards />,
    apr: "15.00%",
    apy: "16.18%*",
    renderStakeButton: renderQuintV2StakeButton,
    unstakeDialog: <QuintV2UnstakeDialog />,
    harvestButton: <QuintV2HarvestButton />,
    address: conventionalPoolV2Address,
  },
  {
    name: "Quint/BNB",
    Icon: (props: HTMLProps<HTMLDivElement>) => <LogoIcon color="gradient" {...props} />,
    deprecated: true,
    currentlyStaked: <QuintBNBV1CurrentlyStaked />,
    totalHarvested: <QuintBNBV1TotalHarvested />,
    rewards: <QuintBNBV1Rewards />,
    apr: "33.00%",
    apy: "39.08%*",
    unstakeButton: <QuintBNBV1UnstakeButton />,
    harvestButton: <QuintBNBV1HarvestButton />,
    migrateButton: <QuintBNBV1MigrateButton />,
    address: conventionalBnbPoolV1Address,
  },
  {
    name: "Quint/BNB V2",
    Icon: (props: HTMLProps<HTMLDivElement>) => <LogoIcon color="gradient" {...props} />,
    deprecated: false,
    currentlyStaked: <QuintBNBV2CurrentlyStaked />,
    totalHarvested: <QuintBNBV2TotalHarvested />,
    rewards: <QuintBNBV2Rewards />,
    apr: "33.00%",
    apy: "39.08%*",
    renderStakeButton: renderQuintBNBV2StakeButton,
    unstakeDialog: <QuintBNBV2UnstakeDialog />,
    harvestButton: <QuintBNBV2HarvestButton />,

    address: conventionalBnbPoolV2Address,
  },
];
